import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { BaseText, DataTable } from '@warrenbrasil/nebraska-web';
import { Accordion } from '@/modules/common/components/Accordion';
import { columns } from './columns';
import { IAllocationSection } from './types';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
interface Props {
  sections: IAllocationSection[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationChartLegend',
  props: {
    sections: null
  },
  setup(__props: any) {

const props = __props as {
  sections: IAllocationSection[];
}


const openSectionsMap = ref<Record<number, boolean>>({});
watch(
  () => props.sections,
  sections => {
    const newOpenSectionsMap: Record<number, boolean> = {};
    sections.forEach((_section, index) => {
      newOpenSectionsMap[index] = false;
    });
    openSectionsMap.value = newOpenSectionsMap;
  },
  { immediate: true }
);
const handleToggleAccordion = (
  isOpen: boolean,
  index: number,
  section: IAllocationSection
) => {
  if (!verifyIfSectionHasItems(section)) return;
  openSectionsMap.value[index] = isOpen;
};
const verifyIfSectionHasItems = (section: IAllocationSection) => {
  return section.items && section.items.length > 0;
};

return { __sfc: true,props, openSectionsMap, handleToggleAccordion, verifyIfSectionHasItems, BaseText, DataTable, Accordion, columns, NebraskaColors }
}

})